function requiredArray (value) {
  return value && value.length > 0 ? undefined : 'Requerido'
}

function requiredPlain (value) {
  return value ? undefined : 'Requerido'
}

export function required (value) {
  return (value instanceof Array) ? requiredArray(value) : requiredPlain(value)
}

export function validAutocomplete (value) {
  if (!value) return undefined
  const re = /^.+ - \d{11}$/i
  return re.test(value) ? undefined : 'Formato invalido'
}

export function validLocalidad (value) {
  const re = /^.+ - \(\d+\)$/i
  return re.test(value) ? undefined : 'Formato invalido'
}

export function isNumeric (value, min = null, max = null) {
  const slice = '\\d' + (min || max ? `{${[min, max].join(',')}}` : '+')
  const re = RegExp(`^${slice}$`, 'i')
  return re.test(value) ? undefined : 'No es numerico o largo incorrecto'
}

export function validLength (value, min = null, max = null) {
  return value && (value.length < min || value.length > max)
    ? `Debe contener entre ${min} y ${max} caracteres`
    : undefined
}

export function isString (value) {
  return value && /[^a-zA-Z]/i.test(value)
    ? 'Debe contener solo caracteres de texto'
    : undefined
}

export function isDecimal (value) {
  const slice = '\\d+|\\d+\\.\\d+'
  const re = RegExp(`^${slice}$`, 'i')
  return re.test(value) ? undefined : 'No es decimal'
}

export function isEmail (value) {
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i
  return emailRegex.test(value) ? undefined : 'No es una dirección de correo válida'
}

export function getNumericValidator (min = null, max = null) {
  return (value) => isNumeric(value, min, max)
}

export function getStringValidator (min = null, max = null) {
  return (value) => validLength(value, min, max)
}

export function comprobarPesos (value, allValues) {
  return (parseInt(allValues.pesoBruto) - parseInt(allValues.pesoNeto) - parseInt(allValues.pesoTara) !== 0) ? 'Los pesos no coinciden' : undefined
}

export function validarTelefono (value) {
  const regex = /^\d{7,15}$/
  if (!value) return undefined
  return regex.test(value) ? undefined : 'El número de teléfono debe contener entre 7 y 15 dígitos'
}
